import { Injectable } from '@angular/core';

import { AuthJwtTokenStore } from '@ts/shared/authentication/data-access';

import { BormaDagoAuthenticatedApiConsumerService } from './borma-dago-api-authenticated-consumer.service';

/**
 * Calls Borma Dago API with authentication information attached.
 *
 * If the user is not authenticated, the request will be retried later when they finally log in.
 */
@Injectable({
  providedIn: 'root',
})
export class BormaDagoPersistentAuthenticatedApiConsumerService extends BormaDagoAuthenticatedApiConsumerService {
  protected override getAuthenticationState$(): AuthJwtTokenStore['state$'] {
    return this.tokenStore.state$;
  }
}
